export default {
	namespaced: true,

	state: {
		// default styles
		AlertBorder: {
			default: 'top'
		},
		AlertColor: {
			default: null
		},
		AlertColoredBorder: {
			default: true
		},
		AlertDark: {
			dark: true,
			light: false
		},
		AlertDense: {
			default: false
		},
		AlertElevation: {
			default: 4
		},
		AlertIcon: {
			default: null
		},
		AlertLight: {
			dark: false,
			light: true
		},
		AlertOutlined: {
			default: false
		},
		AlertProminent: {
			default: true
		},
		AlertText: {
			default: false
		},
		AlertTile: {
			default: false
		},
		BannerColor:{
			default: null
		},
		BannerDark: {
			dark: true,
			light: false
		},
		BannerElevation: {
			default: null
		},
		BannerIconColor: {
			default: null
		},
		BannerLight: {
			dark: false,
			light: true
		},
		BannerOutlined: {
			default: true
		},
		BannerRounded: {
			default: false
		},
		BannerShaped: {
			default: false
		},
		BannerSingleLine: {
			default: false
		},
		BannerTile: {
			default: false
		},
		BlockButtonBlock: {
			default: true
		},
		BlockButtonColor: {
			default: 'primary'
		},
		BlockButtonDark: {
			dark: true,
			light: false
		},
		BlockButtonDepressed: {
			default: false
		},
		BlockButtonElevation: {
			default: 0
		},
		BlockButtonFlat: {
			default: false
		},
		BlockButtonLarge: {
			default: false
		},
		BlockButtonLight: {
			dark: false,
			light: true
		},
		BlockButtonOutlined: {
			default: false
		},
		BlockButtonRounded: {
			default: false
		},
		BlockButtonSmall: {
			default: false
		},
		BlockButtonTile: {
			default: false
		},
		ButtonBlock: {
			default: false
		},
		ButtonColor: {
			default: 'primary'
		},
		ButtonDark: {
			dark: true,
			light: false
		},
		ButtonDepressed: {
			default: false
		},
		ButtonElevation: {
			default: 0
		},
		ButtonFlat: {
			default: false
		},
		ButtonLarge: {
			default: false
		},
		ButtonLight: {
			dark: false,
			light: true
		},
		ButtonOutlined: {
			default: false
		},
		ButtonRounded: {
			default: false
		},
		ButtonSmall: {
			default: false
		},
		ButtonTile: {
			default: false
		},
		CancelButtonBlock: {
			default: false
		},
		CancelButtonColor: {
			default: null
		},
		CancelButtonDark: {
			dark: true,
			light: false
		},
		CancelButtonDepressed: {
			default: false
		},
		CancelButtonElevation: {
			default: 0
		},
		CancelButtonFlat: {
			default: false
		},
		CancelButtonLarge: {
			default: false
		},
		CancelButtonLight: {
			dark: false,
			light: true
		},
		CancelButtonOutlined: {
			default: false
		},
		CancelButtonRounded: {
			default: false
		},
		CancelButtonSmall: {
			default: false
		},
		CancelButtonTile: {
			default: false
		},
		CardColor: {
			default: null
		},
		CardDark: {
			dark: true,
			light: false
		},
		CardElevation: {
			default: 4
		},
		CardFlat: {
			default: false
		},
		CardHover: {
			default: false
		},
		CardLight: {
			dark: false,
			light: true
		},
		CardOutlined: {
			default: false
		},
		CardRaised: {
			default: false
		},
		CardTile: {
			default: false
		},
		CarouselContinuous: {
			default: false
		},
		CarouselCycle: {
			default: true
		},
		CarouselDark: {
			dark: true,
			light: false
		},
		CarouselDelimiterIcon: {
			default: 'fiber_manual_record'
		},
		CarouselFlat: {
			default: false
		},
		CarouselHideDelimiters: {
			default: true
		},
		CarouselHideDelimiterBackground: {
			default: true
		},
		CarouselInterval: {
			default: 6000
		},
		CarouselLight: {
			dark: false,
			light: true
		},
		CarouselNextIcon: {
			default: 'keyboard_arrow_right'
		},
		CarouselPrevIcon: {
			default: 'keyboard_arrow_left'
		},
		CarouselProgress: {
			default: true
		},
		CarouselProgressColor: {
			default: 'primary'
		},
		CarouselShowArrows: {
			default: false
		},
		CarouselShowArrowsOnHover: {
			default: false
		},
		ChipColor: {
			default: null
		},
		ChipDark: {
			dark: true,
			light: false
		},
		ChipLabel: {
			default: false  // Removes circle edges
		},
		ChipLight: {
			dark: false,
			light: true
		},
		ChipOutlined: {
			default: false
		},
		ChipSmall: {
			default: false
		},
		ChipTextColor: {
			default: null
		},
		FlatButtonBlock: {
			default: false
		},
		FlatButtonColor: {
			default: null
		},
		FlatButtonDark: {
			dark: true,
			light: false
		},
		FlatButtonDepressed: {
			default: false
		},
		FlatButtonElevation: {
			default: 0
		},
		FlatButtonFlat: {
			default: true
		},
		FlatButtonLarge: {
			default: false
		},
		FlatButtonLight: {
			dark: false,
			light: true
		},
		FlatButtonOutlined: {
			default: false
		},
		FlatButtonRounded: {
			default: false
		},
		FlatButtonSmall: {
			default: false
		},
		FlatButtonTile: {
			default: false
		},
		FlatCardColor: {
			default: null
		},
		FlatCardDark: {
			dark: true,
			light: false
		},
		FlatCardElevation: {
			default: 0
		},
		FlatCardFlat: {
			default: true
		},
		FlatCardHover: {
			default: false
		},
		FlatCardLight: {
			dark: false,
			light: true
		},
		FlatCardOutlined: {
			default: false
		},
		FlatCardRaised: {
			default: false
		},
		FlatCardTile: {
			default: false
		},
		FlatSheetColor: {
			default: null
		},
		FlatSheetDark: {
			dark: true,
			light: false
		},
		FlatSheetElevation: {
			default: 0
		},
		FlatSheetLight: {
			dark: false,
			light: true
		},
		LabelChipColor: {
			default: 'transparent'
		},
		LabelChipDark: {
			dark: true,
			light: false
		},
		LabelChipLabel: {
			default: true  // Removes circle edges
		},
		LabelChipLight: {
			dark: false,
			light: true
		},
		LabelChipOutlined: {
			default: false
		},
		LabelChipSmall: {
			default: false
		},
		LabelChipTextColor: {
			default: null
		},
		LargeButtonBlock: {
			default: false
		},
		LargeButtonColor: {
			default: 'primary'
		},
		LargeButtonDark: {
			dark: true,
			light: false
		},
		LargeButtonDepressed: {
			default: false
		},
		LargeButtonElevation: {
			default: 0
		},
		LargeButtonFlat: {
			default: false
		},
		LargeButtonLarge: {
			default: true
		},
		LargeButtonLight: {
			dark: false,
			light: true
		},
		LargeButtonOutlined: {
			default: false
		},
		LargeButtonRounded: {
			default: false
		},
		LargeButtonSmall: {
			default: false
		},
		LargeButtonTile: {
			default: false
		},
		ListColor: {
			default: null
		},
		ListDark: {
			dark: true,
			light: false
		},
		ListDense: {
			default: false
		},
		ListElevation: {
			default: null
		},
		ListFlat: {
			default: false
		},
		ListLight: {
			dark: false,
			light: true
		},
		ListNav: {
			default: false
		},
		ListRounded: {
			default: false
		},
		ListShaped: {
			default: false
		},
		ListThreeLine: {
			default: false
		},
		ListTile: {
			default: true
		},
		ListTwoLine: {
			default: false
		},
		MenuButtonBlock: {
			default: false
		},
		MenuButtonColor: {
			default: null
		},
		MenuButtonDark: {
			dark: true,
			light: false
		},
		MenuButtonDepressed: {
			default: false
		},
		MenuButtonElevation: {
			default: 0
		},
		MenuButtonFlat: {
			default: true
		},
		MenuButtonLarge: {
			default: true
		},
		MenuButtonLight: {
			dark: false,
			light: true
		},
		MenuButtonOutlined: {
			default: false
		},
		MenuButtonRounded: {
			default: false
		},
		MenuButtonSmall: {
			default: false
		},
		MenuButtonTile: {
			default: false
		},
		OutlinedButtonBlock: {
			default: false
		},
		OutlinedButtonColor: {
			default: null
		},
		OutlinedButtonDark: {
			dark: true,
			light: false
		},
		OutlinedButtonDepressed: {
			default: false
		},
		OutlinedButtonElevation: {
			default: 0
		},
		OutlinedButtonFlat: {
			default: false
		},
		OutlinedButtonLarge: {
			default: false
		},
		OutlinedButtonLight: {
			dark: false,
			light: true
		},
		OutlinedButtonOutlined: {
			default: true
		},
		OutlinedButtonRounded: {
			default: false
		},
		OutlinedButtonSmall: {
			default: false
		},
		OutlinedButtonTile: {
			default: false
		},
		OutlinedCardColor: {
			default: null
		},
		OutlinedCardDark: {
			dark: true,
			light: false
		},
		OutlinedCardElevation: {
			default: 0
		},
		OutlinedCardFlat: {
			default: false
		},
		OutlinedCardHover: {
			default: false
		},
		OutlinedCardLight: {
			dark: false,
			light: true
		},
		OutlinedCardOutlined: {
			default: true
		},
		OutlinedCardRaised: {
			default: false
		},
		OutlinedCardTile: {
			default: false
		},
		SheetColor: {
			default: null
		},
		SheetDark: {
			dark: true,
			light: false
		},
		SheetElevation: {
			default: 8
		},
		SheetLight: {
			dark: false,
			light: true
		},
		SmallButtonBlock: {
			default: false
		},
		SmallButtonColor: {
			default: 'primary'
		},
		SmallButtonDark: {
			dark: true,
			light: false
		},
		SmallButtonDepressed: {
			default: false
		},
		SmallButtonElevation: {
			default: 0
		},
		SmallButtonFlat: {
			default: false
		},
		SmallButtonLarge: {
			default: false
		},
		SmallButtonLight: {
			dark: false,
			light: true
		},
		SmallButtonOutlined: {
			default: false
		},
		SmallButtonRounded: {
			default: false
		},
		SmallButtonSmall: {
			default: true
		},
		SmallButtonTile: {
			default: false
		},
		StepperDark: {
			dark: true,
			light: false
		},
		StepperLight: {
			dark: false,
			light: true
		},
		StepperStepColor: {
			default: 'primary'
		},
		StepperActionButtonBlock: {
			default: false
		},
		StepperActionButtonColor: {
			default: 'primary',
			// default step
			backStep: null,
			nextStep: null,
			submit: null,
			confirm: null,
			finish: null,
			// inner step
			backStepInner: null,
			nextStepInner: null,
			// outer step
			backStepOuter: null,
			nextStepOuter: null
		},
		StepperActionButtonDark: {
			dark: true,
			light: false
		},
		StepperActionButtonDepressed: {
			default: false
		},
		StepperActionButtonElevation: {
			default: 0
		},
		StepperActionButtonFlat: {
			default: false
		},
		StepperActionButtonLarge: {
			default: false
		},
		StepperActionButtonLight: {
			dark: false,
			light: true
		},
		StepperActionButtonOutlined: {
			default: false
		},
		StepperActionButtonRounded: {
			default: false
		},
		StepperActionButtonSmall: {
			default: false
		},
		StepperActionButtonTile: {
			default: false
		},
		TextareaAutoGrow: {
			default: true
		},
		TextareaBackgroundColor: {
			default: null
		},
		TextareaClearable: {
			default: false
		},
		TextareaColor: {
			default: null
		},
		TextareaCounter: {
			default: false // boolean or number
		},
		TextareaDark: {
			dark: true,
			light: false
		},
		TextareaFilled: {
			default: false
		},
		TextareaFlat: {
			default: true
		},
		TextareaLight: {
			dark: false,
			light: true
		},
		TextareaOutlined: {
			default: true
		},
		TextareaRows: {
			default: 1 // default value = 3
		},
		TextareaSolo: {
			default: false
		},
		TextareaSoloInverted: {
			default: false // Reduces element opacity until focused
		},
		TextFieldBackgroundColor: {
			default: null
		},
		TextFieldClearable: {
			default: false // also possible with search type input
		},
		TextFieldColor: {
			default: null
		},
		TextFieldCounter: {
			default: false // boolean or number
		},
		TextFieldDark: {
			dark: true,
			light: false
		},
		TextFieldFilled: {
			default: false
		},
		TextFieldFlat: {
			default: true
		},
		TextFieldLight: {
			dark: false,
			light: true
		},
		TextFieldOutlined: {
			default: true
		},
		TextFieldSolo: {
			default: true
		},
		TextFieldSoloInverted: {
			default: false // Reduces element opacity until focused
		},
		// animate css
		AnimatedFadeIn: {
			default: 'animate__animated animate__fadeIn'
		},
		// dummy files
		DummyImage: {
			web: require('~/assets/original/dummy.png'),
			mobile: require('~/assets/original/dummy-mobile.png')
		},
		DummyLoadingImage: {
			web: require('~/assets/original/loading.png'),
			mobile: require('~/assets/original/loading.png')
		},
		DummyReadyImage: {
			web: require('~/assets/original/ready.png'),
			mobile: require('~/assets/original/ready.png')
		},
		DummyVideo: {
			web: require('~/assets/original/dummy.mp4'),
			mobile: require('~/assets/original/dummy.mp4')
		},
		// toolbar
		ToolbarTitleStyle: {
			dark: {
				color: 'white'
			},
			light: {
				color: 'black'
			}
		},
		// index
		IndexPageContainerStyle: {
			web: {
				'background-image': 'url(' + require('~/assets/original/wallpaper.png') + ')'
			},
			mobile: {
				'background-image': 'url(' + require('~/assets/original/wallpaper-mobile.png') + ')'
			}
		},
		IndexPageTitleSheetStyle: {
			dark: {
				'background-color': '#21212175'
			},
			light: {
				'background-color': '#ffffff75'
			}
		},
		// sales
		DummyImageProduct: {
			default: require('~/assets/original/salesProduct.png')
		},
		DummyImageProductCode: {
			default: require('~/assets/original/salesProductCode.png')
		}
	},

	getters: {
		get: state => state
	},

	mutations: {
		setValue (state, [key, value]) {
			state[key] = value;
		},
		setSubValue (state, [key, subKey, value]) {
			state[key][subKey] = value;
		}
	},

	actions: {
	}
}
